//should use map pattern with i18n
// {
//   1 : "general_insurance"
// }
export function getFundLabel(fundCode: number) {
  switch (fundCode) {
    case 1:
      return "מבטחים";
    case 2:
      return "קרן גימלאות מרכזית";
    case 3:
      return "מקפת";
    case 4:
      return "נתיב";
    case 5:
      return "בניין";
    case 6:
      return "חקלאים";
    case 7:
      return "אגד";
    case 8:
      return "הדסה";
    case 10 :
      return localStorage.getItem('lang') === "he" ? 'תוכנית באראקה' :"برنامج باراكة" 
    case 11:
      return "מבטחים-מחלה";
    case 13:
      return "מקפת-מטרה אחרת";
    case 15: // TODO: check it out
      return "בניין-מטרה אחרת";
    case 16:
      return "חקלאים-מחלה";
    default:
      return "";
  }
}
